import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Attacking food!",
  "description": "",
  "published": "2007-01-19T00:00:00.000Z",
  "redirect_from": ["/blog/attacking-food/swizec/317"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Watch this amazing video of a `}<a parentName="p" {...{
        "href": "http://www.chilloutzone.de/files/07010804.html"
      }}>{`bunny attacking a snake`}</a>{`. This is really beyond words, it's madening how bloody awesome this bunny is. He's like Rambo!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      